import IndexClient from '@empathybroker/tsclient-index';
import { IndexResponse } from '@empathybroker/tsclient-index/dist/models/index-response';
import { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance';

import { ActionContext } from 'vuex';

import { CONTAINER, TYPES } from '../../../config';

import { ActionClass, ContextState, IndexState } from '../../../models';

import { AUTH_CONSTS } from '../../../store/auth/auth.consts';
import { CONFIG_CONSTS } from '../../../store/config/config.consts';
import { CONTEXT_CONSTS } from '../../../store/context/context.consts';
import { INDEX_CONSTS } from '../../../store/index/index.consts';

export class ReadJobAction implements ActionClass {

  public static async execute({ commit, rootGetters }: ActionContext<IndexState, any>, id: string): Promise<IndexResponse> {
    try {
      const authToken: string = rootGetters[`${AUTH_CONSTS.moduleName}/${AUTH_CONSTS.getters.token}`];
      const context: ContextState = rootGetters[`${CONTEXT_CONSTS.moduleName}/${CONTEXT_CONSTS.getters.context}`];
      const instanceConfig: Instance = rootGetters[`${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.getters.currentInstance}`];
      const indexClient: IndexClient = CONTAINER.get<(context: ContextState, indexToken: string) => IndexClient>(TYPES.IndexClient)(context,
        instanceConfig.catalog.indexToken);
      const response = await indexClient.read(authToken, id);
      commit(INDEX_CONSTS.mutations.setJobs, [response.data]);
      return response;
    } catch (error) {
      commit(INDEX_CONSTS.mutations.setJobs, []);
      throw error;
    }
  }

}
